import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ServerHardwareController = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3.61111"
            y="12.1963"
            width="52.7778"
            height="36.3924"
            rx="3.89045"
            stroke="black"
            stroke-width="2.77778"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <mask id="path-2-inside-1_13741_27049" fill="white">
            <rect
              x="10.9618"
              y="16.4816"
              width="38.8889"
              height="13.8889"
              rx="1.44948"
            />
          </mask>
          <rect
            x="10.9618"
            y="16.4816"
            width="38.8889"
            height="13.8889"
            rx="1.44948"
            stroke="black"
            stroke-width="4.44444"
            mask="url(#path-2-inside-1_13741_27049)"
          />
          <circle cx="19.3519" cy="21.5742" r="1.38889" fill="black" />
          <circle cx="24.9074" cy="21.5742" r="1.38889" fill="black" />
          <circle cx="30.463" cy="21.5742" r="1.38889" fill="black" />
          <circle cx="36.0185" cy="21.5742" r="1.38889" fill="black" />
          <circle cx="41.5741" cy="21.5742" r="1.38889" fill="black" />
          <circle cx="24.9074" cy="25.2779" r="1.38889" fill="black" />
          <circle cx="30.463" cy="25.2779" r="1.38889" fill="black" />
          <circle cx="36.0185" cy="25.2779" r="1.38889" fill="black" />
          <mask id="path-11-inside-2_13741_27049" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.5555 33.1482H24.8505V42.2666H22.9268V44.4279H12.4815V42.2666H10.5555V33.1482Z"
            />
          </mask>
          <path
            d="M24.8505 33.1482H27.0727C27.0727 31.9209 26.0778 30.926 24.8505 30.926V33.1482ZM10.5555 33.1482V30.926C9.32824 30.926 8.33332 31.9209 8.33332 33.1482H10.5555ZM24.8505 42.2666V44.4888C26.0778 44.4888 27.0727 43.4939 27.0727 42.2666H24.8505ZM22.9268 42.2666V40.0444C21.6995 40.0444 20.7046 41.0393 20.7046 42.2666H22.9268ZM22.9268 44.4279V46.6501C24.1541 46.6501 25.1491 45.6552 25.1491 44.4279H22.9268ZM12.4815 44.4279H10.2593C10.2593 45.6552 11.2542 46.6501 12.4815 46.6501V44.4279ZM12.4815 42.2666H14.7037C14.7037 41.0393 13.7088 40.0444 12.4815 40.0444V42.2666ZM10.5555 42.2666H8.33332C8.33332 43.4939 9.32824 44.4888 10.5555 44.4888V42.2666ZM24.8505 30.926H10.5555V35.3705H24.8505V30.926ZM27.0727 42.2666V33.1482H22.6283V42.2666H27.0727ZM22.9268 44.4888H24.8505V40.0444H22.9268V44.4888ZM25.1491 44.4279V42.2666H20.7046V44.4279H25.1491ZM12.4815 46.6501H22.9268V42.2057H12.4815V46.6501ZM10.2593 42.2666V44.4279H14.7037V42.2666H10.2593ZM10.5555 44.4888H12.4815V40.0444H10.5555V44.4888ZM8.33332 33.1482V42.2666H12.7778V33.1482H8.33332Z"
            fill="black"
            mask="url(#path-11-inside-2_13741_27049)"
          />
          <mask id="path-13-inside-3_13741_27049" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.9617 33.1482H50.2566V42.2666H47.8691V44.4279H38.3522V42.2666H35.9617V33.1482Z"
            />
          </mask>
          <path
            d="M50.2566 33.1482H52.4788C52.4788 31.9209 51.4839 30.926 50.2566 30.926V33.1482ZM35.9617 33.1482V30.926C34.7344 30.926 33.7394 31.9209 33.7394 33.1482H35.9617ZM50.2566 42.2666V44.4888C51.4839 44.4888 52.4788 43.4939 52.4788 42.2666H50.2566ZM47.8691 42.2666V40.0444C46.6418 40.0444 45.6468 41.0393 45.6468 42.2666H47.8691ZM47.8691 44.4279V46.6501C49.0964 46.6501 50.0913 45.6552 50.0913 44.4279H47.8691ZM38.3522 44.4279H36.13C36.13 45.6552 37.1249 46.6501 38.3522 46.6501V44.4279ZM38.3522 42.2666H40.5744C40.5744 41.0393 39.5795 40.0444 38.3522 40.0444V42.2666ZM35.9617 42.2666H33.7394C33.7394 43.4939 34.7344 44.4888 35.9617 44.4888V42.2666ZM50.2566 30.926H35.9617V35.3705H50.2566V30.926ZM52.4788 42.2666V33.1482H48.0344V42.2666H52.4788ZM47.8691 44.4888H50.2566V40.0444H47.8691V44.4888ZM50.0913 44.4279V42.2666H45.6468V44.4279H50.0913ZM38.3522 46.6501H47.8691V42.2057H38.3522V46.6501ZM36.13 42.2666V44.4279H40.5744V42.2666H36.13ZM35.9617 44.4888H38.3522V40.0444H35.9617V44.4888ZM33.7394 33.1482V42.2666H38.1839V33.1482H33.7394Z"
            fill="black"
            mask="url(#path-13-inside-3_13741_27049)"
          />
        </SVGIconRender>
  );
};

export default ServerHardwareController;
